function getUserAccountState(state) {
  return {
    userAccount: state.usuarios.account.userAccount,
    isLoading: state.usuarios.account.loading,
    fetched: state.usuarios.account.fetched,
    fetchError: state.usuarios.account.fetchAccountError,
    success: state.usuarios.account.success,
    savingError: state.usuarios.account.savingAccountError,
    errors: state.usuarios.account.errors,
    sentData: state.usuarios.account.sentData,
    path: state.usuarios.account.path
  };
}

export { getUserAccountState };
